import { combineReducers } from 'redux'

import featureToggle from './featureToggleReducer'
import filterVisesITabell from './filterVisesITabellReducer'
import informasjonstekst from './informasjonstekstReducer'
import kodeverk from './kodeverkReducer'
import nullstillFilter from './nullstillFilterReducer'
import omStatistikkenKodeverk from './omStatistikkenReducer'
import sokETO from './sokETOReducer'
import sokETOResultat from './sokETOResultReducer'
import standardrapporter from './standardrapporterReducer'
import tilbakemeldingBruker from './tilbakemeldingBrukerReducer'
import valgtFilter from './valgtFilterReducer'
import valgtSide from './valgtSideReducer'

export default combineReducers({
    kodeverk,
    sokETO,
    sokETOResultat,
    tilbakemeldingBruker,
    standardrapporter,
    valgtFilter,
    filterVisesITabell,
    omStatistikkenKodeverk,
    featureToggle,
    nullstillFilter,
    informasjonstekst,
    valgtSide
})
